import React from 'react';
import { duckify } from 'utils/duckify';
import {
  checklistAnswerLinks
} from 'ducks';
import { compose } from 'redux';
import {connect} from 'react-redux';

import ModalComponent from 'components/ModalComponent';
import { Button } from 'react-bootstrap';

const ChecklistAnswerUnlinker = ({ allDucksReady, dispatch, linkId }) => {
  const onSubmit = () => {
    dispatch(checklistAnswerLinks.actions.remove({id: linkId})).then(window.location.reload(false))
  }
  return <ModalComponent
    title='Unlink Form'
    buttons={[<Button className='btn danger' onClick={() => onSubmit()}>Confirm</Button>]}
    className={'checklist-answer-unlinker'}
  >
    <div>
      Are you sure you want to unlink this form?
    </div>
  </ModalComponent>;
};


export default connect()(ChecklistAnswerUnlinker);
